export const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>, callback: () => any): void => {
  // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
  if (event.key === 'Enter') {
    event.preventDefault();
    event.stopPropagation();
    callback();
  }
};
